import React, { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import {
  getters,
  actions
} from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver/model";
import { noop } from "utils/General";

import Loading from "ui-kit/Loading";

import getTemplate from "components/Global/Module/Feed/Utils/get-template";
import getBodyTemplate from "components/Global/Module/Feed/Utils/get-body-template";
import getColor from "components/Global/Module/Feed/Utils/get-color";

import CSSModules from "react-css-modules";
import Item from "./Item";
import Avatar from "./Item/Avatar";
import Message from "./Item/Message";
import Body from "./Item/Body";
import Action from "./Item/Action";
import Timestamp from "./Item/Timestamp";
import css from "./styles.scss";
import { user } from "redux/modules/user/selectors";
import TextArea from "react-textarea-autosize";

const decorate = R.compose(
  CSSModules(css),
  connect(
    state => ({
      messages: getters.messages(state),
      loading: getters.loadingMessages(state),
      user: user(state)
    }),
    {
      initMessages: actions.initMessages,
      sendMessage: actions.sendMessage
    }
  )
);

const Messages = ({
  messages = [],
  initMessages = noop,
  loading = true,
  user = {},
  sendMessage = noop
}) => {
  useEffect(() => {
    initMessages();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <div className={css.items}>
        {R.map(
          item => (
            <Item key={`${item.user.id}_${item.created_at}`}>
              <Avatar color={getColor(item?.user, user)} />
              <Message>
                <Action>{getTemplate(item, user)}</Action>
                <Body>{getBodyTemplate(item)}</Body>
                <Timestamp stamp={item?.created_at} />
              </Message>
            </Item>
          ),
          messages
        )}
      </div>

      <div className={css.sendMessage}>
        <Avatar style={{ fontSize: 24, height: 35, width: 35 }} />
        <TextArea
          type="text"
          aria-label={"Send a message..."}
          placeholder={"Send a message..."}
          onKeyDown={e => {
            const message = e.target?.value;
            if (e.key === "Enter" && message?.length > 0) {
              sendMessage({ message });
            }
          }}
        />
      </div>
    </div>
  );
};

export default decorate(Messages);
